import type { ReactNode } from "react";
import type {
    MODAL_RETAILER_DEBUG,
    MODAL_RETAILER_EXTERNAL_QR_CODE,
    RetailerDebugModalType,
    RetailerExternalQrCodeModalType,
} from "../../../../shared-logic/features/retailer/utils/modalConstants";
import type { MODAL_ERRORS, ModalErrorsType } from "../../../../common-deprecated/utils/modalConstants";
import type { CmcModelDataType } from "../../shared-logic/types/CmcModelDataType";

export const MODAL_DEBUG_FINANCE = "debugFinance" as const;
export const MODAL_DEBUG_LCV_FILTERS = "debugLcvFilters" as const;
export const MODAL_GRADE_SELECTOR_COMPARE = "gradeSelectorCompare" as const;
export const MODAL_MOBILE_GRADE_SELECTOR_FILTER = "gradeSelectorFilter" as const;
export const MODAL_MOBILE_GRADE_SELECTOR_LCV_FILTER = "gradeSelectorLcvFilter" as const;
export const MODAL_DISCLAIMER = "disclaimerModal" as const;

export type GradeSelectorModalIdsType =
    | typeof MODAL_DEBUG_FINANCE
    | typeof MODAL_DEBUG_LCV_FILTERS
    | typeof MODAL_RETAILER_DEBUG
    | typeof MODAL_GRADE_SELECTOR_COMPARE
    | typeof MODAL_MOBILE_GRADE_SELECTOR_FILTER
    | typeof MODAL_MOBILE_GRADE_SELECTOR_LCV_FILTER
    | typeof MODAL_ERRORS
    | typeof MODAL_RETAILER_EXTERNAL_QR_CODE
    | typeof MODAL_DISCLAIMER;

export type DebugFinanceModalType = {
    type: typeof MODAL_DEBUG_FINANCE;
};

export type GradeSelectorCompareModalType = {
    type: typeof MODAL_GRADE_SELECTOR_COMPARE;
    models: CmcModelDataType[];
};

export type GradeSelectorFilterModalType = {
    type: typeof MODAL_MOBILE_GRADE_SELECTOR_FILTER;
};

export type GradeSelectorLcvFilterModalType = {
    type: typeof MODAL_MOBILE_GRADE_SELECTOR_LCV_FILTER;
};

export type DebugLcvFiltersModalType = {
    type: typeof MODAL_DEBUG_LCV_FILTERS;
};

export type DisclaimerModalType = {
    type: typeof MODAL_DISCLAIMER;
    content?: ReactNode;
};

export type GradeSelectorModalsType =
    | DebugFinanceModalType
    | DebugLcvFiltersModalType
    | GradeSelectorCompareModalType
    | RetailerDebugModalType
    | RetailerExternalQrCodeModalType
    | GradeSelectorFilterModalType
    | GradeSelectorLcvFilterModalType
    | ModalErrorsType
    | DisclaimerModalType;
